
import Charts from "react-apexcharts"
import ApexCharts from 'apexcharts'
import React, { useEffect } from 'react'

import styled from 'styled-components'

const ResponsiveChart = styled(Charts)`
    max-width: 1500px;
    width: 100%;
    margin: 0px auto;
    flex-wrap: wrap;
`

function UpdatableChart({
    series,
    options,
    ...props
}) {

    useEffect(() => { // or useEffect
        ApexCharts.exec(options.chart.id, 'updateSeries', series)
        ApexCharts.exec(options.chart.id, 'updateOptions', options, false, true, true)
    }, [series, options])

    return  (
        <ResponsiveChart
            options={options}
            series={series}
            type='line'
            height='600'
        />
    )
}

export default UpdatableChart